import { Lock } from "lucide-react";

import { InertAct } from "./inert-act.js";

/**
 * D2's guarded control (`EQUIPE-GESTURES` R5, designer's review 45abddea, rows 1 and 2; C1's « no sentence of its own » is superseded by
 * the drawing, both texts kept): the inert primary is the PALE-INDIGO button (D2's `#DCDDF6` ground and `#34307A` ink, the bank theme's `--hk-guard-bg` and `--hk-guard-ink`), and its reason stands BESIDE it in a lock chip (amber ground, 8 px radius). `aria-disabled`, never
 * `disabled` (`InertAct`): the click and the two keys are cancelled, and the button points at the reason it hears.
 */
const INERT_PRIMARY =
  "cursor-not-allowed whitespace-nowrap rounded-xl border border-[color:var(--hk-guard-bg)] bg-[color:var(--hk-guard-bg)] px-4 py-2 text-sm font-semibold text-[color:var(--hk-guard-ink)]";

const INERT_QUIET =
  "cursor-not-allowed whitespace-nowrap rounded-[10px] border border-transparent bg-transparent px-3 py-1.5 text-sm font-semibold text-[color:var(--hk-text-2)]";
const INERT_SMALL = "min-h-[34px] px-3 py-1.5";

/**
 * `quiet` is D2's quiet inert act (« Voir ses dossiers (0) »: transparent, the muted ink), `small` its 34 px row size, `wrap` lets the pair
 * wrap where the row's actions do. The default is the modal's one-row, no-wrap pair.
 */
export function GuardedAct(props: {
  readonly testId: string;
  readonly reasonId: string;
  readonly reason: string | null;
  readonly children: string;
  readonly quiet?: boolean;
  readonly small?: boolean;
  readonly wrap?: boolean;
}): React.JSX.Element {
  const base = props.quiet === true ? INERT_QUIET : INERT_PRIMARY;
  return (
    <span className={`flex min-w-0 ${props.wrap === true ? "flex-wrap" : "flex-nowrap"} items-center gap-3`}>
      <InertAct
        describedBy={props.reasonId}
        testId={props.testId}
        className={`${base} ${props.small === true ? INERT_SMALL : ""} shrink-0`}
      >
        {props.children}
      </InertAct>
      {props.reason === null ? null : (
        <span
          id={props.reasonId}
          data-testid={`${props.testId}-raison`}
          className="inline-flex min-w-0 items-center gap-1.5 rounded-lg bg-amber-50 px-3 py-1.5 text-sm text-amber-700"
        >
          <Lock className="h-3.5 w-3.5" aria-hidden="true" />
          {props.reason}
        </span>
      )}
    </span>
  );
}
